module.exports = __webpack_public_path__ + "static/img/barber.38f8d49d.jpg";